import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

const PDetailsTab = ({ status, start_date, end_date, description }) => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        padding={3}
        borderRadius={2}
        backgroundColor="white.main"
      >
        <Box display="flex" gap={10}>
          <Box display="flex" flexDirection="column" gap={2}>
            <Typography color="light-gray-text.main">Status</Typography>
            <Typography color="light-gray-text.main">Evaluation period</Typography>
          </Box>
          <Box display="flex" flexDirection="column" gap={2}>
            {status === 'Active' ? (
              <Typography color="positive.main" variant="body1">
                {status}
              </Typography>
            ) : (
              <Typography variant="body1">{status}</Typography>
            )}
            <Typography>
              {start_date} - {end_date}
            </Typography>
          </Box>
        </Box>
        <Box>
          {description && (
            <Typography color="light-gray-text.main" mb={0.5}>
              Description
            </Typography>
          )}
          <Typography>{description}</Typography>
        </Box>
      </Box>
    </>
  )
}

export default PDetailsTab
